import { render, staticRenderFns } from "./WideHeader.vue?vue&type=template&id=928d5bac&scoped=true&"
import script from "./WideHeader.vue?vue&type=script&lang=js&"
export * from "./WideHeader.vue?vue&type=script&lang=js&"
import style0 from "./WideHeader.vue?vue&type=style&index=0&id=928d5bac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928d5bac",
  null
  
)

export default component.exports